import React from 'react';
import { DataTableRowCheckbox } from './DataTableRowCheckbox';
import { notesSelectionColumnClassName } from './NotesListLayout';

interface SelectableNoteRowProps {
  noteId: string;
  selected: boolean;
  ariaLabel: string;
  onSelectRange: (noteId: string) => void;
  onToggle: (noteId: string, selected: boolean) => void;
  children: React.ReactNode;
}

export const SelectableNoteRow: React.FC<SelectableNoteRowProps> = ({
  noteId,
  selected,
  ariaLabel,
  onSelectRange,
  onToggle,
  children,
}) => {
  return (
    <div className="flex items-start gap-3">
      <div className={`${notesSelectionColumnClassName} pt-[1.125rem]`}>
        <DataTableRowCheckbox
          checked={selected}
          rowId={noteId}
          ariaLabel={ariaLabel}
          onSelectRange={onSelectRange}
          onToggle={onToggle}
        />
      </div>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
};
